
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/[slug]/[hash]",
      function () {
        return require("private-next-pages/products/[slug]/[hash]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/products/[slug]/[hash]"])
      });
    }
  